import { defineMessages } from 'react-intl';

export default defineMessages({
    allOpen: {
        id: 'ent.gateway.directives.ActivitySummary.All Open',
        defaultMessage: 'All Open',
    },
    allCompleted: {
        id: 'ent.gateway.directives.ActivitySummary.All Completed',
        defaultMessage: 'All Completed',
    },
    allClosed: {
        id: 'ent.gateway.directives.ActivitySummary.All Closed',
        defaultMessage: 'All Closed',
    },
    overdue: {
        id: 'ent.gateway.directives.ActivitySummary.Overdue',
        defaultMessage: 'Overdue Only',
    },
    openAssignedToMe: {
        id: 'ent.gateway.directives.ActivitySummary.Open, Assigned to me',
        defaultMessage: 'Open, Assigned to me',
    },
    activityType: {
        id: 'ent.gateway.directives.activity-summary.Type',
        defaultMessage: 'Type',
    },
    activtyDueDate: {
        id: 'ent.gateway.directives.activity-summary.Due Date',
        defaultMessage: 'Due Date',
    },
    activitySubject: {
        id: 'ent.gateway.directives.activity-summary.Subject',
        defaultMessage: 'Subject',
    },
    activityAssignedTo: {
        id: 'ent.gateway.directives.activity-summary.Assign To',
        defaultMessage: 'Assign To',
    },
    activityPriority: {
        id: 'ent.gateway.directives.activity-summary.Priority',
        defaultMessage: 'Priority',
    },
    activityDescription: {
        id: 'ent.gateway.directives.activity-summary.Description',
        defaultMessage: 'Description',
    },
    activityTypePlaceHolder: {
        id: 'ent.gateway.directives.activity-summary.Please select activity type',
        defaultMessage: 'Please select activity type',
    },
    activityPriorityPlaceHolder: {
        id: 'ent.gateway.directives.activity-summary.Priority.select',
        defaultMessage: '--Choose Priority--',
    },
    noTypeSelected: {
        id: 'ent.gateway.directives.add-activity.Close',
        defaultMessage: 'Close',
    },
    noActivityType: {
        id: 'ent.gateway.directives.add-activity.You must choose an activity type',
        defaultMessage: 'No Activity Type Selected',
    },
    noActivityTypeMessage: {
        id: 'ent.gateway.directives.add-activity.You must first select an activity type',
        defaultMessage: 'You must first select an activity type.',
    },
    activityCreated: {
        id: 'ent.gateway.directives.add-activity.Your Activity has been created',
        defaultMessage: 'Your Activity has been created',
    },
    searchActivities: {
        id: 'ent.gateway.directives.activity-summary.Search activities',
        defaultMessage: 'Search activities',
    },
    activity: {
        id: 'ent.gateway.directives.activity-summary.Activity',
        defaultMessage: 'Activity',
    },
    cancel: {
        id: 'ent.gateway.directives.activity-summary.Cancel',
        defaultMessage: 'Cancel',
    },
    createActivity: {
        id: 'ent.gateway.directives.activity-summary.Create Activity',
        defaultMessage: 'Create Activity',
    },
    addActivity: {
        id: 'ent.gateway.directives.activity-summary.Add an Activity',
        defaultMessage: 'Add an Activity',
    },
});
